<mat-card>
    <div class="header">
        <div class="title">Outage Definitions</div>
        <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
            <vulcan-icon size="24px" icon="download"></vulcan-icon>
        </button>
    </div>
    <mat-card-content>
        <dl>
            @for (definition of definitions; track definition.title) {
            <dt>{{definition.title}}</dt>
            <dd>{{definition.description}}</dd>
            }
        </dl>
    </mat-card-content>
</mat-card>
